import React from 'react';
import { useHistory } from 'react-router-dom';
import DateHelpers from '@/core/helpers/DateHelper';
import { CardDiscountFullCycle, FooterPiggy, PayItemCard } from './styled';
import { DivisionLine } from '../../courses/modules/myCourses/components/MyCoursesCollapsibles/styled';
import { FeeTag } from '../modules/PayOnline/PayOnline.styled';
import iconPiggy from '../../../../assets/icons/payments/icon-Piggy-Discount.svg';
import iconProntoPago from '../../../../assets/icons/payments/iconPorcentageProntoPago.svg';

interface PayItemProps {
  itemNumber?: string;
  name: string;
  amount: string;
  amountWithBenefits?: string;
  status: string;
  paymentType: {
    id: string;
    desc: string;
  };
  hasDiscountProntoPago?: boolean | null;
  dueDate: number;
  dateCreate?: number;
  billingDate?: number;
  billName?: string;
  recharge?: string;
  periodDesc?: string;
  amountToPay: string;
  amountToPayStr?: string;
  discountProntoPago?: number;
  discountCicloCompleto?: number;
  discountBene?: number;
  isPasarela?: boolean;
  isFullCycleDiscount?: boolean;
  exonerationDatePSE?: number | null;
  datePayment?: number;
}

const PayItem = ({
  itemNumber = '',
  name,
  amount,
  amountWithBenefits = '0.00',
  status,
  paymentType,
  hasDiscountProntoPago = null,
  dueDate,
  dateCreate,
  billingDate = 0,
  billName = '',
  recharge = '0.00',
  periodDesc,
  amountToPay,
  amountToPayStr = '0.00',
  discountProntoPago = 0,
  discountCicloCompleto = 0,
  discountBene = 0,
  isPasarela = false,
  isFullCycleDiscount = false,
  exonerationDatePSE = null,
  datePayment = 0
}: PayItemProps) => {
  const history = useHistory();
  let tag: any;

  switch (status) {
    case 'Por vencer':
      tag = 'default';
      break;
    case 'Vencido':
      tag = 'expired';
      break;
    case 'Pagado':
      tag = 'payed';
      break;
    default:
      tag = '';
  }

  const handleClick = () => {
    if (isPasarela) return;
    history.push({
      pathname: '/pagos/detalle',
      state: {
        itemNumber,
        name,
        amount,
        amountWithBenefits,
        status,
        paymentType,
        hasDiscountProntoPago,
        dueDate,
        dateCreate,
        datePayment,
        billingDate,
        billName,
        recharge,
        periodDesc,
        amountToPay,
        amountToPayStr,
        discountProntoPago,
        discountCicloCompleto,
        discountBene,
        isFullCycleDiscount,
        exonerationDatePSE
      }
    });
  };
  const getBillingDateText = (billingDateTemp?: number): string => {
    if (billingDateTemp) {
      return `Fecha de pago: ${DateHelpers.formatDateExtended2(
        Number(billingDateTemp),
        true
      )}`;
    }
    return 'Fecha de pago: -';
  };

  const renderContent = ({ nameClass }: { nameClass?: string }) => (
    <>
      <PayItemCard
        className={nameClass}
        isFullCycleDiscount={isFullCycleDiscount}
        isPse={exonerationDatePSE !== null}
        isPasarela={isPasarela}
        onClick={handleClick}
        style={{
          marginBottom:
            isPasarela || isFullCycleDiscount || exonerationDatePSE ? 0 : '8px',
          cursor: isPasarela ? 'default' : 'pointer',
          padding: isPasarela ? 0 : '16px 0'
        }}
      >
        <div
          className="firstLine"
          style={{ padding: isPasarela ? 0 : '0 16px' }}
        >
          <span>
            {name}
            {hasDiscountProntoPago && status !== 'Pagado' && !isPasarela && (
              <img src={iconProntoPago} alt="" />
            )}
          </span>
          {status === 'Vencido' ? (
            <span style={{ color: 'var(--support-error)' }}>
              S/ {amountToPayStr}
            </span>
          ) : (
            <div>
              <span>S/ {amountToPayStr}</span>
            </div>
          )}
        </div>
        {status === 'Vencido' && !isPasarela && (
          <p className="mora">¡Paga hoy y evita que la mora crezca!</p>
        )}

        {
          <DivisionLine
            backgroundColor="var(--card-focus)"
            style={{ margin: '8px 0 10px 0' }}
          />
        }

        <div
          className="secondLine"
          style={{ padding: isPasarela ? 0 : '0 16px' }}
        >
          {paymentType?.id === '08' ? ( // Si es un trámite
            <>
              <span>
                {status !== 'Pagado'
                  ? `Fecha de creación: ${DateHelpers.formatDateExtended2(
                      Number(dateCreate)
                    )}`
                  : getBillingDateText(datePayment)}
              </span>
              {status === 'Pagado' && tag && (
                <FeeTag className={tag}>{status}</FeeTag>
              )}
            </>
          ) : (
            <>
              <span>
                {status !== 'Pagado'
                  ? `Vencimiento: ${DateHelpers.formatDateExtended2(
                      Number(dueDate)
                    )}`
                  : getBillingDateText(datePayment)}
              </span>
              {tag && <FeeTag className={tag}>{status}</FeeTag>}
            </>
          )}
        </div>
      </PayItemCard>
      {exonerationDatePSE && !isPasarela && (
        <FooterPiggy isPse={exonerationDatePSE !== null}>
          <span>
            Si tienes otro seguro, valídalo hasta el{' '}
            {DateHelpers.formatDateExtended2(Number(exonerationDatePSE))}
          </span>
        </FooterPiggy>
      )}
    </>
  );

  return isFullCycleDiscount ? (
    <CardDiscountFullCycle tabIndex={0}>
      {renderContent({ nameClass: 'pay-item-card' })}
      <FooterPiggy>
        <img src={iconPiggy} alt="PiggyIcon" />
        <span>¡Descuento 10% activado!</span>
      </FooterPiggy>
    </CardDiscountFullCycle>
  ) : (
    renderContent({})
  );
};

export { PayItem };
